import logo from "./logo.svg";
import AppRouter from "routes";
import "./App.scss";

function App() {
  return <AppRouter />;
}

export default App;
